import { fromPairs } from "lodash";
import * as all from "./all-metrics";

// Central registry of all metric configs, isolated from type definitions to avoid circular deps
export const allMetrics = fromPairs(Object.entries(all));
